import React from 'react';
import { Download, HeartHandshake, LockKeyhole, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const trustItems = [{
  icon: Download,
  label: 'Descarga inmediata'
}, {
  icon: LockKeyhole,
  label: 'Sin suscripción'
}, {
  icon: HeartHandshake,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}];
export function HeroSection() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section className="overflow-hidden px-4 pb-10 pt-3 text-center md:pb-14 md:pt-6" data-id="element-76" data-mp="30kiwk61622qr">
      <div className="mx-auto max-w-5xl" data-id="element-77" data-mp="2mte4bp04ocqg">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.08
      }} className="mx-auto max-w-3xl font-display text-3xl font-black leading-[1.05] tracking-tight text-brand-greenDark md:text-5xl" data-id="element-78" data-mp="2rsqscd2qjpum">
          Planificá un año entero de Biología en solo <span className="text-brand-greenBright" data-id="element-79" data-mp="3kb4irrlqs9jo">5 minutos</span>
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.16
      }} className="mx-auto mt-3 max-w-xl text-sm font-medium leading-relaxed text-brand-gray md:text-base" data-id="element-80" data-mp="2fdfn3cw8fkmw">
          Más de 2.000 docentes de LATAM ya dejaron de improvisar. Llegá a cada clase con la teoría, las actividades y las evaluaciones listas para imprimir.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.22
      }} className="mx-auto mt-3 max-w-2xl" data-id="element-81" data-mp="2z1y8rki14fwu">
          <img src="https://cdn.magicpatterns.com/uploads/r1Lo4Gyowm8UkQrGQTyvWu/ChatGPT_Image_16_jul_2026,_21_18_12-Photoroom.png" alt="Pack Biología Lista con cinco tomos, monitor, tablet y celular" className="w-full object-contain" data-id="element-82" data-mp="384phhcjisxks" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="mt-4" data-id="element-83" data-mp="1ds97q1rin1b6">
          <CTAButton onClick={scrollToPricing} ariaLabel="Ver oferta del Pack Biología Lista" className="w-full max-w-md text-base md:w-auto md:px-10 md:py-5" data-id="element-84" data-mp="38tl31msngrxd">QUIERO EL PACK BIOLOGÍA LISTA</CTAButton>
          <p className="mt-4 text-sm font-bold text-brand-gray" data-id="element-85" data-mp="3irr3dzyt5q04">Acceso inmediato · Pago único · Garantía de 7 días</p>
        </motion.div>
        <div aria-label="Beneficios de compra" className="mx-auto mt-7 flex max-w-4xl flex-wrap justify-center gap-2" data-id="element-86" data-mp="3mtvv2t5p4ck4">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-brand-green/15 bg-white px-3 py-2 text-xs font-bold text-brand-greenDark shadow-sm" data-id="element-87" data-mp="lcnhvgzb5z3"><Icon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-88" data-mp="5eysd1gwi5kc" />{label}</span>)}
        </div>
      </div>
    </section>;
}